// extracted by mini-css-extract-plugin
export default {"controls":"lsf-controls","controls__tooltip-wrapper":"lsf-controls__tooltip-wrapper","controls__skipped-info":"lsf-controls__skipped-info","button":"lsf-button"};
    if(module.hot) {
      // 1637785518427
      var cssReload = require("/Users/nicholasrq/Git/label-studio-frontend/node_modules/mini-css-extract-plugin/dist/hmr/hotModuleReplacement.js")(module.id, {"locals":true});
      module.hot.dispose(cssReload);
      
    }
  